export const getControlByObjectiveAndSystemsQuery = () => {
    return `
    query ControlByObjectiveAndSystems(
        $objectiveId:Int!,
        $mainSystemId:Int!,
        $hrSystemId:Int,
        $ticketSystemId:Int
    ){
        controlByObjectiveAndSystems(
            objectiveId: $objectiveId,
            mainSystemId: $mainSystemId,
            hrSystemId: $hrSystemId,
            ticketSystemId: $ticketSystemId
        ) {
            id
            systemConsolidations
        }
    }`
}